/* JCKED homepage (jx-*) interactions. Delegated so it survives theme-editor section reloads. */
(function () {
  if (window.__jxHome) return;
  window.__jxHome = true;

  function openDrawer(drawer, trigger) {
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    document.documentElement.style.overflow = 'hidden';
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var close = drawer.querySelector('[data-jx-drawer-close]');
    if (close) close.focus();
  }

  function closeDrawer(drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.querySelectorAll('[data-jx-drawer-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    var opener = document.querySelector('[data-jx-drawer-open]');
    if (opener) opener.focus();
  }

  function embedUrl(provider, id) {
    if (provider === 'youtube') return 'https://www.youtube.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0';
    if (provider === 'vimeo') return 'https://player.vimeo.com/video/' + id + '?autoplay=1';
    return '';
  }

  function openVideo(card) {
    var modal = document.querySelector('[data-jx-modal]');
    if (!modal) return;
    var stage = modal.querySelector('[data-jx-modal-stage]');
    stage.innerHTML = '';
    var src = card.getAttribute('data-video-src');
    var provider = card.getAttribute('data-video-provider');
    var id = card.getAttribute('data-video-id');
    var el;
    if (src) {
      el = document.createElement('video');
      el.src = src;
      el.controls = true;
      el.autoplay = true;
      el.playsInline = true;
    } else if (provider && id) {
      el = document.createElement('iframe');
      el.src = embedUrl(provider, id);
      el.allow = 'autoplay; fullscreen; picture-in-picture';
      el.allowFullscreen = true;
      el.title = card.getAttribute('data-video-title') || 'Customer video';
    } else {
      return; // no video attached to this card yet
    }
    stage.appendChild(el);
    if (typeof modal.showModal === 'function') modal.showModal();
    else modal.setAttribute('open', '');
    modal._jxOpener = card;
  }

  function closeVideo(modal) {
    var stage = modal.querySelector('[data-jx-modal-stage]');
    if (stage) stage.innerHTML = ''; // stops playback
    if (typeof modal.close === 'function') modal.close();
    else modal.removeAttribute('open');
    if (modal._jxOpener) modal._jxOpener.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    var open = t.closest('[data-jx-drawer-open]');
    if (open) {
      var d = document.getElementById(open.getAttribute('aria-controls'));
      if (d) openDrawer(d, open);
      return;
    }
    var close = t.closest('[data-jx-drawer-close]');
    if (close) {
      var dd = close.closest('.jx-drawer');
      if (dd) closeDrawer(dd);
      return;
    }
    if (t.classList && t.classList.contains('jx-drawer__overlay')) {
      closeDrawer(t.closest('.jx-drawer'));
      return;
    }

    var facts = t.closest('[data-jx-facts-toggle]');
    if (facts) {
      var panel = document.getElementById(facts.getAttribute('aria-controls'));
      if (panel) {
        var isOpen = panel.classList.toggle('is-open');
        facts.setAttribute('aria-expanded', String(isOpen));
        var icon = facts.querySelector('[data-jx-facts-icon]');
        if (icon) icon.style.transform = isOpen ? 'rotate(45deg)' : '';
      }
      return;
    }

    var vcard = t.closest('[data-jx-video]');
    if (vcard) {
      openVideo(vcard);
      return;
    }
    var vclose = t.closest('[data-jx-modal-close]');
    if (vclose) {
      closeVideo(vclose.closest('[data-jx-modal]'));
      return;
    }
    if (t.hasAttribute && t.hasAttribute('data-jx-modal')) closeVideo(t); // backdrop click
  });

  /* Header dropdowns open on click; opening one, clicking elsewhere or pressing Escape closes the rest. */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.jx-dd[open]').forEach(function (dd) { if (!dd.contains(e.target)) dd.removeAttribute('open'); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.jx-dd[open]');
    if (open) { open.removeAttribute('open'); var b = open.querySelector('summary'); if (b) b.focus(); return; }
    var d = document.querySelector('.jx-drawer.is-open');
    if (d) closeDrawer(d);
  });

  document.addEventListener('close', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-jx-modal')) {
      var stage = e.target.querySelector('[data-jx-modal-stage]');
      if (stage) stage.innerHTML = '';
    }
  }, true);

  /* Slider dots follow the scroll position of their track */
  function syncDots(track) {
    var dots = track.parentElement.querySelectorAll('.jx-dots i');
    if (!dots.length) return;
    var cards = track.children;
    var idx = 0;
    var max = track.scrollWidth - track.clientWidth;
    if (max > 0 && track.scrollLeft >= max - 4) {
      idx = cards.length - 1;
    } else {
      var best = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs(cards[i].offsetLeft - track.offsetLeft - track.scrollLeft - 20);
        if (dist < best) { best = dist; idx = i; }
      }
    }
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
  }

  function initTracks(root) {
    (root || document).querySelectorAll('[data-jx-track]').forEach(function (track) {
      if (track._jxBound) return;
      track._jxBound = true;
      track.addEventListener('scroll', function () { window.requestAnimationFrame(function () { syncDots(track); }); }, { passive: true });
      syncDots(track);
    });
  }

  initTracks();
  document.addEventListener('shopify:section:load', function (e) { initTracks(e.target); });
})();
